import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import UserList from '../views/cadastros/usuarios/List.vue';
import PesoList from '../views/cadastros/peso/List.vue';
import NutricionistaList from '../views/cadastros/nutricionista/List.vue';
import PerfilAcessoList from '../views/cadastros/perfil_acesso/List.vue';
import FuncoesList from '../views/cadastros/cadastro_basico/FuncoesList.vue';

let adminRoutes = {
    path: "/admin",
    component: DashboardLayout,
    name: "Admin",
    icon: "settings",
    redirect: "/admin/usuarios",
    children: [
        {
            path: "usuarios",
            name: "Usuários",
            icon: "image",
            components: { default: UserList }
        },
        {
            path: "profissionais",
            name: "Profissionais",
            icon: "person_pin",
            components: { default: NutricionistaList }
        },
        {
            path: "pesos",
            name: "Pesos",
            icon: "image",
            components: { default: PesoList }
        },
        {
            path: "perfil_acesso",
            name: "Perfil de Acesso",
            icon: "supervisor_account",
            components: { default: PerfilAcessoList }
        },
        {
            path: "funcoes",
            name: "Funções",
            icon: "recent_actors",
            components: { default: FuncoesList }
        },

    ]
};

export default adminRoutes;